import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateEmployeePaycardSsnInquiryRequest,
  TCreatePaycardSsnInquiryResponse,
} from "../createEmployeePaycardSsnInquiry/createEmployeePaycardSsnInquiry.schema";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const createContractorPaycardSsnInquiry = (axios: IAxiosInstance) => {
  return async ({
    workerId,
  }: TCreateEmployeePaycardSsnInquiryRequest): Promise<TCreatePaycardSsnInquiryResponse> => {
    const { data } = await axios.noRetry.post<IApiResponse<TCreatePaycardSsnInquiryResponse>>(
      `/api/contractors/${workerId}/paycards/ssn-inquiry`
    );

    return data.data;
  };
};
